<template>
  <div
    :class="
      subtask.done
        ? 'subtask_done tasks_row_body subtask'
        : 'tasks_row_body subtask'
    "
    :data-id="subtask._id"
    @contextmenu.prevent="ContextMenu"
    @click="tabTask(subtask._id)"
  >
    <router-link
      :to="linkToTask(subtask._id)"
      class="tasks_row"
      :class="task_class"
      :id="`task_${subtask._id}`"
      @click="
        fetch_comments({ task_id: subtask._id, project_id: subtask.project_id })
      "
    >
      <h4
        class="task_title"
        :id="subtask.local_id"
        v-if="subtask.name && !isEdit"
        :class="{ 'ml-0': $route.params.chat_id }"
      >
        {{ subtask.name }}
      </h4>
      <input
        v-else-if="isEdit"
        class="task_title task_title-edit"
        ref="renameTaskInputNode"
        v-model="editingText"
        type="text"
        :class="{ 'ml-0': $route.params.chat_id }"
        @blur="handleSave"
        @keyup.exact.enter="handleSave"
        @click.prevent.stop="() => {}"
        @focus.prevent.stop="() => {}"
      />
      <div v-else class="task__input-name">
        <input
          type="text"
          v-model="task_name"
          ref="add_task"
          @keyup.enter="addSubTask(subtask)"
          @blur="clearSubTask(subtask)"
        />
      </div>

      <div v-if="subtask.name" style="display: flex; height: 100%">
        <div class="task__priority">
          <div
            class="task__priority__title"
            @click.prevent="openPriorityMenu"
            :style="`background-color: ${
              priority_color == 'transparent' ? '#f3f3f3' : priority_color
            }; color: ${
              priority_color == 'transparent'
                ? '#f3f3f3'
                : priority_color == '#F4F915' || priority_color == '#f3f3f3'
                ? '#000'
                : '#fff'
            }`"
          >
            <p>{{ enumPriority[priority_text] }}</p>
            <svg
              width="8"
              height="5"
              viewBox="0 0 8 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.57221 0.99729C0.705674 0.997029 0.835015 1.04351 0.937781 1.12867L3.99944 3.68766L7.06681 1.22006C7.12523 1.17261 7.19246 1.13718 7.26463 1.1158C7.33679 1.09442 7.41247 1.08751 7.48732 1.09547C7.56216 1.10343 7.6347 1.12611 7.70075 1.16219C7.7668 1.19828 7.82507 1.24706 7.87221 1.30574C7.91965 1.36417 7.95509 1.4314 7.97647 1.50356C7.99785 1.57573 8.00476 1.65141 7.99679 1.72625C7.98883 1.8011 7.96616 1.87363 7.93007 1.93968C7.89399 2.00573 7.8452 2.064 7.78653 2.11114L4.3593 4.87006C4.25709 4.95407 4.12889 5 3.99658 5C3.86428 5 3.73607 4.95407 3.63387 4.87006L0.20664 2.01403C0.1488 1.96608 0.10099 1.90719 0.0659451 1.84073C0.0309005 1.77427 0.00931025 1.70156 0.00241232 1.62674C-0.00448513 1.55193 0.00344515 1.47649 0.0257473 1.40474C0.0480499 1.333 0.0842862 1.26635 0.132383 1.20864C0.185535 1.14311 0.252544 1.09017 0.328592 1.05363C0.404641 1.01709 0.48784 0.997848 0.57221 0.99729Z"
                :fill="
                  priority_color == 'transparent'
                    ? '#898989'
                    : priority_color == '#F4F915' || priority_color == '#f3f3f3'
                    ? '#000'
                    : '#fff'
                "
              />
            </svg>
          </div>
          <div class="task__priority__lists" v-if="show_menu">
            <div
              class="task__priority__list"
              style="background-color: #f3f3f3; color: #000"
              v-if="priority_text != 'Normal'"
              @click.prevent="priorityChange('#f3f3f3', 'Normal')"
            >
              {{ this.$t("task.priority.normal") }}
            </div>
            <div
              class="task__priority__list"
              style="background-color: #f4f915; color: #000000"
              v-if="priority_text != 'Medium'"
              @click.prevent="priorityChange('#F4F915', 'Medium')"
            >
              {{ this.$t("task.priority.medium") }}
            </div>
            <div
              class="task__priority__list"
              style="background-color: #f12e2e"
              v-if="priority_text != 'High'"
              @click.prevent="priorityChange('#F12E2E', 'High')"
            >
              {{ this.$t("task.priority.high") }}
            </div>
          </div>
        </div>

        <div class="task__date">
          <span v-html="assignDateTask(subtask.assign.date)"></span>
        </div>

        <!-- <div class="mtb-auto">
                    <span v-if="get_unreaded_messages_in_tasks[subtask._id] > 0" class="unread_messages">
                        {{ get_unreaded_messages_in_tasks[subtask._id] }}
                    </span>
                </div> -->

        <div
          class="mtb-auto unread-container"
          v-if="get_unreaded_messages_in_tasks[subtask._id] > 0"
          :class="{ 'flex-must': task_class == 'tasks_row_completed' }"
        >
          <p
            v-if="
              getListsMentions[$route.params.project_id] &&
              getListsMentions[$route.params.project_id][subtask._id] &&
              getListsMentions[$route.params.project_id][subtask._id].mentions >
                0
            "
            class="unread-container__mention"
          >
            @
          </p>
          <p
            v-if="get_unreaded_messages_in_tasks[subtask._id] > 0"
            class="unread_messages unread-container__count"
          >
            {{ unread_msg[subtask._id] }}
          </p>
        </div>

        <div v-if="assign_name1 || subtask.assign.user_id" style="height: 100%">
          <div class="task__priority__assign_to">
            <!-- <span :style="`border: 1px solid ${priority_color == 'transparent' ? '#898989' : priority_color}; color: ${priority_color == 'transparent' ? '#898989' : priority_color}`" v-if="assign_name1" v-html="$w_user_image(assign_name1, 70, false)"></span>
                        <span :style="`border: 1px solid ${priority_color == 'transparent' ? '#898989' : priority_color}; color: ${priority_color == 'transparent' ? '#898989' : priority_color}`" v-else v-html="$w_user_image(userName_Assign(subtask.assign.user_id), 70, false)"></span> -->
            <span
              :style="{
                border: '1px solid ' + assign_name1.color,
                color: assign_name1.color,
              }"
              v-if="assign_name1"
              v-html="$w_user_image(assign_name1, 70, true)"
            ></span>
            <span
              :style="{
                border:
                  '1px solid ' + userName_Assign(subtask.assign.user_id).color,
                color: userName_Assign(subtask.assign.user_id).color,
              }"
              v-else
              v-html="
                $w_user_image(userName_Assign(subtask.assign.user_id), 70, true)
              "
            ></span>
            <!-- <span v-if="assign_name1.name" :style="{backgroundColor: assign_name1.color, color: 'white'}">{{assign_name1.name[0]}}</span> -->
          </div>
        </div>

        <div
          class="task__priority-line"
          :style="`background-color: ${priority_color};${
            priority_text != 'Normal' ? 'opacity: 1;' : 'opacity: 0;'
          }`"
        ></div>
      </div>
    </router-link>
    <el-checkbox
      v-model="subtask.done"
      @input="change_complete_sub"
    ></el-checkbox>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import RenameElement from "@/components/app/RenameElement";
import { EventEmitter } from "../../main";
import File from "../../utils/aws";

export default {
  name: "SubTask",
  props: {
    parent: [String],
    subtask: {
      type: Object,
      required: true,
    },
    done: [Boolean],
    chat_id: [String],
    project_id: [String],
  },
  data() {
    return {
      task_class: "",
      show_menu: false,
      priority_color: "transparent",
      priority_text: "Normal",
      task_name: "",
      assign_name1: "",
      assign_date1: "",
      isEdit: false,
      unread_msg: [],
      editingText: "",
      enumAssign: {
        Today: this.$t("task.assign.today"),
        Yesterday: this.$t("task.assign.yesterday"),
        Tomorrow: this.$t("task.assign.tomorrow"),
      },
      enumPriority: {
        Normal: this.$t("task.priority.normal"),
        Medium: this.$t("task.priority.medium"),
        High: this.$t("task.priority.high"),
      },
      //   project_id: ''
    };
  },
  mounted() {
    this.editingText = this.subtask.name;

    this.unread_msg = this.get_unreaded_messages_in_tasks;

    // this.project_id = this.subtask.project_id

    // this.show_menu = this.subtask.show

    // EventEmitter.$on('SubTaskDone', (data) => {
    //     if (data.task_id == this.subtask._id) {
    //         this.subtask.done
    //     }
    // })

    EventEmitter.$on("RenameTaskFromContext", (taskId) => {
      if (taskId == this.subtask._id) {
        this.isEdit = true;
        console.log(this.subtask, "sunbtask");
        setTimeout(() => {
          this.$refs.renameTaskInputNode.focus();
        }, 0);
      }
    });

    EventEmitter.$on("AssignDate", (data) => {
      if (data.date) {
        if (data.task_id == this.subtask._id) {
          this.assign_date1 = data.date;
        }
      } else {
        this.assign_date1 = "";
      }
    });

    EventEmitter.$on("AssignUser", (data) => {
      // console.log('00000000000000000')
      this.assign_name1 = "";
      if (data.user_id) {
        if (data.task_id == this.subtask._id) {
          this.subtask.assign.user_id = true;
          if (this.getUserData._id == data.user_id) {
            this.assign_name1 = this.getUserData;
          } else {
            this.getKnownUsers.forEach((e) => {
              if (e._id == data.user_id) {
                this.assign_name1 = e;
              }
            });
          }
        }
      } else {
        if (data.task_id == this.subtask._id) {
          this.subtask.assign.user_id = false;
        }
        this.assign_name1 = "";
      }
    });

    this.priority_text = this.subtask.priority
      ? this.subtask.priority
      : "Normal";

    if (this.priority_text == "Normal") {
      this.priority_color = "#f3f3f3";
    } else if (this.priority_text == "Medium") {
      this.priority_color = "#F4F915";
    } else if (this.priority_text == "High") {
      this.priority_color = "#F12E2E";
    }

    this.subtask_class = this.subtask.done ? "tasks_row_completed" : "";
    EventEmitter.$on("Priority", (data) => {
      if (data.task_id == this.subtask._id) {
        this.priority_text = data.priority;
        if (this.priority_text == "Normal") {
          this.priority_color = "#f3f3f3";
        } else if (this.priority_text == "Medium") {
          this.priority_color = "#F4F915";
        } else if (this.priority_text == "High") {
          this.priority_color = "#F12E2E";
        }
      }
    });

    // EventEmitter.$on('addSubTask', (data) => {
    //     if (data._id == this.subtask._id) {
    //         this.subtask = data
    //     }
    // })

    EventEmitter.$on("removeTask", (data) => {
      if (data == this.subtask._id) {
        document
          .querySelector(
            `.tasks_row_body.subtask[data-id="${this.subtask._id}"]`
          )
          .classList.add("removeTask");
        setTimeout(() => {
          this.deleteTask(this.subtask);

          // let size = document.querySelector(`[data-id="${this.subtask.parent}"] .draggable_tasks.subtask .transition-group__subtask`).offsetHeight

          // let sub = []
          // // console.log(this.getSubTask.filter(e => e.parent == 'B2GShgYilkxyBdazZNaUh2I='))
          // this.getSubTask.forEach((e, i) => {
          //     if (this.subtask.parent == e.parent) {
          //         sub.push(e)
          //     }
          // })

          // let w = sub.length * 38 - 1
          // document.querySelector(`[data-id="${this.subtask.parent}"] .draggable_tasks.subtask`).style.height = w + 'px'
        }, 300);
      }
    });
  },
  methods: {
    ...mapActions([
      "socket_completed_task",
      "socket_delete_task",
      "socket_rename_task",
      "socket_add_task",
    ]),
    ...mapMutations(["setUserFileSize_minus"]),
    handleSave() {
      this.isEdit = false;
      this.socket_rename_task({
        name:
          this.editingText.trim() != "" ? this.editingText.trim() : "Untitled",
        task_id: this.subtask._id,
        project_id: this.project_id,
      });
    },
    clearSubTask(subtask) {
      subtask.project_id = this.project_id;
      if (this.task_name == "") {
        EventEmitter.$emit("clearSubTask", subtask);
      } else {
        this.subtask.name = this.task_name;
        EventEmitter.$emit("offAddSubTask", false);
        // console.log(this.subtask)
        setTimeout(() => {
          this.socket_add_task(this.subtask);
          // let size = document.querySelector(`[data-id="${this.subtask.parent}"] .draggable_tasks.subtask .transition-group__subtask`).offsetHeight

          // let sub = []
          // this.getSubTask.forEach((e, i) => {
          //     if (this.subtask.parent == e.parent) {
          //         sub.push(e)
          //     }
          // })

          // let w = sub.length * 38 - 1

          // document.querySelector(`[data-id="${this.subtask.parent}"] .draggable_tasks.subtask`).style.height = w + 'px'
        }, 0);
      }
    },
    ContextMenu(e) {
      // e.stopPropagation()
      let position_menu = {
        x: e.x,
        y: e.y,
        task_id: this.subtask._id,
        list_id: this.subtask.project_id,
        task: this.subtask,
      };

      setTimeout(() => {
        EventEmitter.$emit("ContextMenu_open", position_menu);
      }, 10);
    },
    addSubTask() {
      // this.subtask.name = this.task_name
      document.querySelector(".task__input-name input").blur();
      // EventEmitter.$emit('offAddSubTask', false)

      // setTimeout(() => {
      //     // let size = document.querySelector(`[data-id="${this.subtask.parent}"] .draggable_tasks.subtask .transition-group__subtask`).offsetHeight

      //     let sub = []
      //     this.getSubTask.forEach((e, i) => {
      //         if (this.subtask.parent == e.parent) {
      //             sub.push(e)
      //         }
      //     })

      //     let w = sub.length * 38 - 1

      //     document.querySelector(`[data-id="${this.subtask.parent}"] .draggable_tasks.subtask`).style.height = w + 'px'
      // }, 0)
      // console.log(this.subtask)
      // setTimeout(() => {
      //     this.socket_add_task(this.subtask)
      // }, 0);
    },
    assignDate(date) {
      if (date) {
        if (!isNaN(date)) {
          date = new Date(+date).toISOString();
        }
        const today = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate()
        ).getTime();

        const yestarday = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 1
        ).getTime();

        const tomorrow = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() + 1
        ).getTime();

        const date_from_comment = new Date(
          new Date(date).getFullYear(),
          new Date(date).getMonth(),
          new Date(date).getDate()
        ).getTime();

        if (date_from_comment == today) {
          return "Today";
        } else if (date_from_comment == yestarday) {
          return "Yesterday";
        } else if (date_from_comment == tomorrow) {
          return "Tomorrow";
        } else {
          if (new Date().getFullYear() == new Date(date).getFullYear()) {
            return new Intl.DateTimeFormat("en-GB", {
              day: "numeric",
              month: "short",
            }).format(new Date(date));
          } else {
            return (
              new Intl.DateTimeFormat("en-GB", {
                day: "numeric",
                month: "short",
              }).format(new Date(date)) +
              ", " +
              new Date(date).getFullYear()
            );
          }
        }
      }
    },
    userName_Assign(user_id) {
      const users = this.getKnownUsers;
      let name;
      if (this.getUserData._id == user_id) {
        name = this.getUserData;
      } else {
        users.forEach((e) => {
          if (e._id == user_id) {
            name = e;
          }
        });
      }
      return name;
    },
    priorityChange(color, text) {
      this.priority_color = color;
      this.priority_text = text;
      this.show_menu = !this.show_menu;
      this.$socket.emit("IN_Priority", {
        task_id: this.subtask._id,
        project_id: this.project_id,
        priority: text,
        author: JSON.stringify({
          name: this.getUserData.name,
          id: this.getUserData._id,
        }),
      });
    },
    openPriorityMenu() {
      this.show_menu = !this.show_menu;
    },
    tabTask: function (task_id) {
      EventEmitter.$emit("Note_Size", task_id);
      // Проверяем vuex getAssigns есть ли там данные
      let send_data = true;
      this.getAssigns.forEach((e) => {
        if (e.task_id == this.$route.params.task_id) {
          setTimeout(() => {
            send_data = false;
            if (e.user_id) {
              let data = {
                assign: e,
                update: false,
              };
              EventEmitter.$emit("AssignFind", data);
            } else {
              e.user_id = "";
              let data = {
                assign: e,
                update: false,
              };
              EventEmitter.$emit("AssignFind", data);
            }
          }, 100);
          // EventEmitter.$emit('AssignUser', data)
        }
      });
      // Если нет данных то мы отправляем данные в бек
      if (send_data) {
        // this.$socket.emit('IN_AssignFind', {
        //     task_id: task_id
        // })
      }
      // const assign = this.getAssigns.find((e) => e.task_id == task_id)
      // if(assign){
      //     console.log(assign)
      // }else{
      //     console.log(this.$store.state.getAssigns)
      //     // this.$on('AssignFind', (data) => {
      //     //     console.log(data)
      //     // })
      // }
    },
    linkToTask(task_id) {
      setTimeout(() => {
        if (document.querySelector(".right_col_sidebar")) {
          document
            .querySelector(".right_col_sidebar")
            .classList.add("run_anime");
        }
      }, 10);
      // localStorage.setItem('project_id', this.project_id)
      if (this.chat_id) {
        return `/chats/${this.chat_id}/project/${this.project_id}/task/${task_id}`;
      } else {
        if (this.$route.matched[0].name == "Inbox") {
          return `/inbox/${this.$route.params.project_id}/task/${task_id}`;
        } else {
          return `/project/${this.$route.params.project_id}/task/${task_id}`;
        }
        // return `/project/${this.$route.params.project_id}/task/${task_id}`;
      }
    },
    change_complete_sub() {
      // alert(this.subtask.done)
      this.$emit("change_complete_sub", {
        complete: this.subtask.done,
        task_id: this.subtask._id,
      });
    },
    deleteTask(task) {
      let body_to_del = {
        project_id: this.project_id,
        task_id: task._id,
        task_file_size: task.file_size,
      };
      this.$emit("delete_task", body_to_del);
      if (
        this.$route.params.task_id &&
        this.$route.params.task_id == task._id
      ) {
        this.$router.push(`/project/${this.project_id}`);
      }
      // const comments = this.getComments[task._id]
      // comments.forEach((e) => {
      //     e.files.forEach((f) => {
      //         this.setUserFileSize_minus(+f.size)
      //     })
      // })
      this.socket_delete_task(body_to_del);
      const aws = new File();
      const remove = aws.removeFolder(
        "Lists" + "/" + this.project_id + "/" + task._id + "/"
      );
    },
    assignDateTask(date) {
      if (isNaN(date)) {
        date = new Date(date).getTime();
      }

      if (isNaN(this.assign_date1)) {
        this.assign_date1 = new Date(this.assign_date1).getTime();
      }

      if (this.assign_date1) {
        if (
          this.assignDate(this.assign_date1) == "Today" ||
          this.assignDate(this.assign_date1) == "Yesterday"
        ) {
          return `<p style="color: #FF8686">${
            this.enumAssign[this.assignDate(this.assign_date1)]
              ? this.enumAssign[this.assignDate(this.assign_date1)]
              : this.assignDate(this.assign_date1)
          }</p>`;
        } else {
          if (this.assign_date1 > Date.now()) {
            return `<p style="color: #489CDC">${
              this.enumAssign[this.assignDate(this.assign_date1)]
                ? this.enumAssign[this.assignDate(this.assign_date1)]
                : this.assignDate(this.assign_date1)
            }</p>`;
          } else {
            return `<p style="color: #FF8686">${
              this.enumAssign[this.assignDate(this.assign_date1)]
                ? this.enumAssign[this.assignDate(this.assign_date1)]
                : this.assignDate(this.assign_date1)
            }</p>`;
          }
        }
      } else {
        if (date) {
          if (
            this.assignDate(date) == "Today" ||
            this.assignDate(date) == "Yesterday"
          ) {
            return `<p style="color: #FF8686">${
              this.enumAssign[this.assignDate(date)]
                ? this.enumAssign[this.assignDate(date)]
                : this.assignDate(date)
            }</p>`;
          } else {
            if (date > Date.now()) {
              return `<p style="color: #489CDC">${
                this.enumAssign[this.assignDate(date)]
                  ? this.enumAssign[this.assignDate(date)]
                  : this.assignDate(date)
              }</p>`;
            } else {
              return `<p style="color: #FF8686">${
                this.enumAssign[this.assignDate(date)]
                  ? this.enumAssign[this.assignDate(date)]
                  : this.assignDate(date)
              }</p>`;
            }
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      "get_flag_for_unreaded",
      "get_unreaded_messages_in_tasks",
      "get_active_task_window",
      "getTasks",
      "getAssigns",
      "getComments",
      "getKnownUsers",
      "getUserData",
      "getSubTask",
      "get_flag_for_add_task",
      "getListsMentions",
    ]),
    getTaskDone() {
      return this.done;
    },
  },
  watch: {
    get_unreaded_messages_in_tasks(newVal) {
      this.unread_msg = newVal;
    },
    get_flag_for_unreaded() {
      this.unread_msg = [];
      this.unread_msg = this.get_unreaded_messages_in_tasks;
    },
    getTaskDone(e) {
      this.subtask_class = e ? "tasks_row_completed" : "";
    },
    get_flag_for_add_task(e) {
      if (!e) {
        // setTimeout(() => {
        //     this.$refs.add_task.focus()
        // }, 0)
      }
    },
    $route() {
      setTimeout(() => {
        this.priority_text = this.subtask.priority
          ? this.subtask.priority
          : "Normal";

        if (this.priority_text == "Normal") {
          this.priority_color = "#f3f3f3";
        } else if (this.priority_text == "Medium") {
          this.priority_color = "#F4F915";
        } else if (this.priority_text == "High") {
          this.priority_color = "#F12E2E";
        }
      }, 10);
    },
    subtask(newVal) {
      this.editingText = newVal.name;
    },
  },
  components: {
    RenameElement,
  },
};

/* 
(typeof task._id == 'number'
          ? getTasks[$route.params.project_id].find((t) => t.local_id == task._id)._id
          : task._id)
*/
</script>
